export const OPEN_HOME_EVENT = 'investalbum:open-home'
export const OPEN_HISTORY_EVENT = 'investalbum:open-history'
export const OPEN_ALBUM_SELECTION_EVENT = 'investalbum:open-album-selection'
export const OPEN_HELP_EVENT = 'investalbum:open-help'
export const OPEN_THEME_REVIEW_EVENT = 'investalbum:open-theme-review'
